export type ReadingProgressBucket = 0 | 25 | 50 | 75 | 100;

export const MIN_READING_COMPLETION_SECONDS = 5;

export function getReadingCompletionThresholdSeconds(estimatedSeconds: number): number {
  return Math.max(MIN_READING_COMPLETION_SECONDS, estimatedSeconds);
}

export function normalizeReadingProgressBucket(progressPercent: number): ReadingProgressBucket {
  const progress = Math.max(0, Math.min(100, Math.floor(progressPercent)));
  return progress >= 95 ? 100 : progress >= 75 ? 75 : progress >= 50 ? 50 : progress >= 25 ? 25 : 0;
}

export function calculateReadingProgress(input: {
  activeSeconds: number;
  completionThresholdSeconds: number;
  viewportBottom: number;
  documentHeight: number;
}): number {
  const completionThresholdSeconds = Math.max(1, input.completionThresholdSeconds);
  const documentHeight = Math.max(1, input.documentHeight);
  const timeProgress = Math.max(0, Math.min(1, input.activeSeconds / completionThresholdSeconds));
  const depthProgress = Math.max(0, Math.min(1, input.viewportBottom / documentHeight));
  return Math.floor(Math.min(timeProgress, depthProgress) * 100);
}
